import React from 'react';
import { Animated, Platform } from 'react-native';
import Icon from '../../Icon';

export type SelectChevronOwnProps = {
    isFocused: boolean;
};

export type SelectChevronProps = SelectChevronOwnProps;

const SelectChevron: React.FC<SelectChevronProps> = (props) => {
    const rotationAnimationRef = React.useRef(new Animated.Value(props.isFocused ? 1 : 0));
    React.useEffect(() => {
        Animated.timing(rotationAnimationRef.current, {
            toValue: props.isFocused ? 1 : 0,
            duration: 200,
            useNativeDriver: Platform.OS === 'web',
        }).start();
    }, [props.isFocused]);

    return (
        <Animated.View
            style={{
                transform: [
                    {
                        rotate: rotationAnimationRef.current.interpolate({
                            inputRange: [0, 1],
                            outputRange: ['0deg', '180deg'],
                        }),
                    },
                ],
            }}
        >
            <Icon name="ChevronDown" size={'button-icon'} />
        </Animated.View>
    );
    return;
};

export default React.memo(SelectChevron);
